import promise from 'promise';
import includes from 'lodash/includes';
import forEach from 'lodash/forEach';

import ExtensionsConstants from 'app/shared/constants/ExtensionsConstants';

// service
import appLogger from 'app/shared/loggers/appLogger';

const photoUtils = {
    hasValidExtension(file) {
        const extension = file.name.split('.').pop().toLowerCase();
        const extensionsWhitelist = Object.values(ExtensionsConstants);
        return includes(extensionsWhitelist, extension);
    },

    preloadImages(fileList) {
        const promiseArr = [];

        // loop through files
        forEach(fileList, (file) => {
            // create a list of promises
            const p = new Promise((resolve) => {
                const img = new Image();

                // handlers
                img.onload = () => {
                    resolve(file);
                };

                img.onerror = () => {
                    // report error
                    appLogger.logError({
                        message: 'image could not be loaded',
                        context: 'photoUtils.preloadImages.onerror',
                    });

                    resolve(false);
                };

                // set source
                img.src = file.preview;
            });

            // append promises
            promiseArr.push(p);
        });

        if (promiseArr.length > 0) {
            return promise
                .all(promiseArr)
                .then((responseList) => {
                    // filter list with only loaded files
                    responseList = responseList.filter((response) => {
                        if (!response) {
                            // TODO: respond with a list of files that have errors
                            return false;
                        }

                        return response;
                    });

                    return responseList;
                })
                .catch((error) => {
                    // report error
                    appLogger.logError({
                        message: error,
                        context: 'photoUtils.preloadImages.catch',
                    });
                });
        }

        return promise.resolve();
    },
};

export default photoUtils;
